export function removeQueryParams(paramsToRemove: string[]): void {
  const url = new URL(window.location.href);

  paramsToRemove.forEach((param) => {
    url.searchParams.delete(param);
  });

  window.history.replaceState({}, '', url.toString());
}
